var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd",
    stroke: "#7C7C96",
    strokeWidth: 1.5,
    opacity: 0.5,
    transform: "translate(3 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.25c2.265 0 4.348-.915 6.075-2.438C16.307 7.727 17.25 6.332 17.25 6c0-.332-.943-1.727-2.175-2.812C13.348 1.665 11.265.75 9 .75s-4.348.915-6.075 2.438C1.693 4.273.75 5.668.75 6c0 .332.943 1.727 2.175 2.812C4.652 10.335 6.735 11.25 9 11.25z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 2.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/showPassword.1fa1016cfafb92d5622675e071fb0d1f.svg";
export { ForwardRef as ReactComponent };